module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomPropertiesFormGenerator"
    }
  }, _vm._l((_vm.propertiesFormSchema), function(property) {
    return _c('div', {
      key: property.Guid
    }, [(property.ChildProperties) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('h4', {
      staticClass: "propertyThemeTitle"
    }, [_vm._v(_vm._s(property.Title))])]) : _vm._e(), _vm._v(" "), (property.ChildProperties) ? _vm._l((property.ChildProperties), function(childProperty) {
      return _c('div', {
        key: childProperty.Guid
      }, [(
        childProperty.Type === 'Group' && childProperty.ChildProperties
      ) ? _c('h5', {
        staticClass: "propertyGroupTitle"
      }, [_vm._v("\n          " + _vm._s(childProperty.Title) + "\n          "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (
            childProperty.Dynamic &&
            childProperty.ChildProperties &&
            childProperty.ChildProperties[0]
          ),
          expression: "\n              childProperty.Dynamic &&\n              childProperty.ChildProperties &&\n              childProperty.ChildProperties[0]\n            "
        }],
        staticClass: "btn btn-default btn-fab btn-fab-mini",
        attrs: {
          "disabled": !_vm.globals.isAccessAllowed(
            'LoopOp_ShopperProperties_Shopper_Update'
          )
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.addDynamicGroup(childProperty)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons text-green"
      }, [_vm._v("add")])])]) : _vm._e(), _vm._v(" "), (childProperty.Dynamic && childProperty.ValueGroups) ? _vm._l((childProperty.ValueGroups), function(valueGroup) {
        return _c('div', {
          key: valueGroup.ValueGroupGuid,
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "dynamicGroupBorder"
        }, [_vm._l((childProperty.ChildProperties), function(property) {
          return _c('div', {
            key: property.Guid,
            staticClass: "col-md-11"
          }, [_c(((property.PropertyType) + "Input"), _vm._b({
            tag: "component",
            attrs: {
              "value": _vm.getShopperValues(property, valueGroup),
              "readOnly": !_vm.globals.isAccessAllowed(
                'LoopOp_ShopperProperties_Shopper_Update'
              )
            },
            on: {
              "input": function($event) {
                return _vm.updateShopperValues(property, valueGroup, $event)
              }
            }
          }, 'component', property, false))], 1)
        }), _vm._v(" "), _c('div', [_c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (childProperty.Dynamic),
            expression: "childProperty.Dynamic"
          }],
          staticClass: "btn btn-default btn-fab btn-fab-mini btn-clear",
          attrs: {
            "disabled": !_vm.globals.isAccessAllowed(
              'LoopOp_ShopperProperties_Shopper_Update'
            )
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeDynamicGroup(
                childProperty,
                valueGroup.ValueGroupGuid
              )
            }
          }
        }, [_c('i', {
          staticClass: "material-icons text-red"
        }, [_vm._v("clear")])])])], 2)])
      }) : (childProperty.Type === 'Property') ? [_c('div', {
        staticClass: "col-md-12 nonDynamicGroup"
      }, [_c(((childProperty.PropertyType) + "Input"), _vm._b({
        tag: "component",
        attrs: {
          "value": _vm.getShopperValues(childProperty, null),
          "readOnly": !_vm.globals.isAccessAllowed(
            'LoopOp_ShopperProperties_Shopper_Update'
          )
        },
        on: {
          "input": function($event) {
            return _vm.updateShopperValues(childProperty, null, $event)
          }
        }
      }, 'component', childProperty, false))], 1)] : _vm._e()], 2)
    }) : _vm._e()], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec1d1af","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperManagement/CustomPropertiesForm.vue
// module id = 1705
// module chunks = 1